import script from "./addressForm.vue?vue&type=script&setup=true&lang=js"
export * from "./addressForm.vue?vue&type=script&setup=true&lang=js"

import "./addressForm.vue?vue&type=style&index=0&id=1b6c5711&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6c5711"]])

export default __exports__